import React, { useState } from "react"; 

export const ZeromagicSVG =
  "https://firebasestorage.googleapis.com/v0/b/zeromagicsite.appspot.com/o/zeroagent%2Fzm.svg?alt=media&token=e453745a-c6f7-4673-9ff6-f47230ec971f";

export const ChevronDown = 'https://firebasestorage.googleapis.com/v0/b/zeromagicsite.appspot.com/o/zeroagent%2Fchevron-down.svg?alt=media&token=55227a87-370e-40cd-8cbf-64cae45225cc';

type Props = {
    appID : string
    appKey : string
}

const ChatFrame: React.FC<Props> = ({
    appID,
    appKey
}) => {
  const [show, setShow] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const isDev:boolean = process.env.NODE_ENV === "development";
  console.log("isDev", isDev);

  let iframeUrl = `https://chat.zeroagent.io/web?appId=${appID}&appKey=${appKey}`;
  let themeIframeUrl = `https://chat.zeroagent.io/web/theme?appId=${appID}&appKey=${appKey}`;

  let iframeUrlDev = `http://localhost:5173/web?appId=${appID}&appKey=${appKey}`;
  let themeIframeUrlDev = `http://localhost:5173/web/theme?appId=${appID}&appKey=${appKey}`;

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  function showChatWidget() {
    setShow(true);
  }

  return (
    <div className="zeroagent-app">
      <div
        className="zeroagent-chat"
        id="zeroagent-chat"
        style={{
          display: isOpen ? "block" : "none",
        }}
      >
        <iframe
          title="zeroagent-chat-frame"
          className="zeroagent-chat-frame"
          id="zeroagent-chat-frame"
          src={isDev? iframeUrlDev: iframeUrl}
        ></iframe>
      </div>

      <div
        className="zeroagent-chat-widget"
        style={{
          display: show ? "flex" : "none",
        }}
        id="zeroagent-chat-widget"
      >
        <div
          onClick={toggleChat}
          style={{
            backgroundColor: "#111111",
          }}
          className={`${
            isOpen ? "zeroagent-chat-open" : "zeroagent-chat-close"
          }`}
          id="zeroagent-chat-button"
        >
          <iframe
            title="zeroagent-btn-frame"
            id="zeroagent-btn-frame"
            className="zeroagent-btn-frame"
            style={{
              pointerEvents: "none",
            }}
            src={isDev ? themeIframeUrlDev : themeIframeUrl}
            onLoad={showChatWidget}
          ></iframe>

          <div className="zeroagent-chat-overlay">
            <img
              src={ChevronDown}
              width="30"
              height="30"
              id="zeroagent-down-icon"
              alt="zeroagent-down-icon"
              style={{
                display: isOpen ? "block" : "none",
              }}
            />

            <div
              className="zeroagent-chat-header"
              id="zeroagent-chat-header"
              style={{
                display: isOpen ? "none" : "flex",
              }}
            >
              <span className="zeroagent-chat-text"> Ask AI </span>
              <img
                width="20"
                height="20"
                src={ZeromagicSVG}
                loading="eager"
                alt="chat-messsage"
                className="zeroagent-chat-icon"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatFrame;
